export const requestTypes = Object.freeze({
	GET: "GET",
	PATCH: "PATCH",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE",
} as const);

export type RequestType = typeof requestTypes[keyof typeof requestTypes];
